import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { isUSBC } from "../../../../../utils/businessType.lib.js";
import { formatTime } from "../../../../../utils/warehouses/warehouseHelpers.js";
import { getWarehouseHoursLabels, getWarehouseHolidayHoursLabels } from "../../../../../utils/warehouses/warehouseHours.js";
import { Text, List, ListItem } from "@nxt-costco-com/forge-components";
import { EXECUTIVE_HOURS_IDENTIFIER, EXECUTIVE_MEMBER_IDENTIFIER, OPENING_HOURS_IDENTIFIER } from "../constants.js";
import { Subheader } from "../styles.js";
const ScheduledHours = ({
  businessHoursLabel,
  closedHolidayLabel,
  executiveMemberLabel,
  executiveMemberHoursLabel,
  hoursLabel,
  locale = "en-us",
  openHolidayLabel,
  warehouseData,
  showHolidays = true,
  sxHoursLabel
}) => {
  var _a, _b;
  if (!(warehouseData == null ? void 0 : warehouseData.hours)) {
    console.error("ScheduledHours: No hours data found");
    return null;
  }
  const executiveHoursData = (_a = warehouseData.hours) == null ? void 0 : _a.filter(
    (item) => {
      var _a2, _b2;
      return (_b2 = (_a2 = item.title) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.value.startsWith(EXECUTIVE_HOURS_IDENTIFIER);
    }
  );
  const allExecutiveOpenHoursSame = executiveHoursData.length > 0 && executiveHoursData.every(
    (item) => item.open === executiveHoursData[0].open
  );
  const businessHoursData = (_b = warehouseData.hours) == null ? void 0 : _b.filter(
    (item) => {
      var _a2, _b2;
      return !((_b2 = (_a2 = item.title) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.value.startsWith(EXECUTIVE_HOURS_IDENTIFIER));
    }
  );
  const allBusinessOpenHoursSame = businessHoursData.length > 0 && businessHoursData.every(
    (item) => item.open === businessHoursData[0].open
  );
  const businessHours = getWarehouseHoursLabels(businessHoursData, locale);
  const holidayHoursLabels = showHolidays ? getWarehouseHolidayHoursLabels(
    warehouseData == null ? void 0 : warehouseData.holidays,
    locale,
    closedHolidayLabel,
    openHolidayLabel
  ) : [];
  const allHours = [...businessHours, ...holidayHoursLabels];
  const hasLabelsForExecutiveHours = businessHoursLabel && executiveMemberLabel && executiveMemberHoursLabel;
  const displayExecutiveMemberHours = isUSBC && hasLabelsForExecutiveHours && allExecutiveOpenHoursSame && executiveHoursData.length > 0 && !(allBusinessOpenHoursSame && executiveHoursData[0].open === businessHoursData[0].open);
  let execLabelParts = ["", "", ""];
  if (displayExecutiveMemberHours && executiveMemberHoursLabel) {
    const [beforeExec, afterExecRaw] = executiveMemberHoursLabel.split(
      EXECUTIVE_MEMBER_IDENTIFIER
    );
    const [betweenExecAndTime, afterTime] = afterExecRaw ? afterExecRaw.split(OPENING_HOURS_IDENTIFIER) : ["", ""];
    execLabelParts = [
      beforeExec || "",
      betweenExecAndTime || "",
      afterTime || ""
    ];
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    hoursLabel && /* @__PURE__ */ jsx(
      Subheader,
      {
        color: "light",
        "data-testid": "warehousetile-seewarehousedetails-hours",
        variant: "t7",
        children: hoursLabel
      }
    ),
    displayExecutiveMemberHours && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Text, { variant: "l2", children: [
        execLabelParts[0],
        /* @__PURE__ */ jsx("b", { children: executiveMemberLabel }),
        execLabelParts[1],
        formatTime(
          executiveHoursData[0].open,
          locale,
          true,
          true
        ),
        execLabelParts[2]
      ] }),
      /* @__PURE__ */ jsx(Text, { bold: true, variant: "l2", children: businessHoursLabel })
    ] }),
    /* @__PURE__ */ jsx(List, { variant: "SimpleList", children: allHours.map((hourLabel) => {
      return /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsx(Text, { sx: sxHoursLabel, variant: "b3", children: hourLabel.label }) }, hourLabel.key);
    }) })
  ] });
};
export {
  ScheduledHours
};
